import {JsonFormsDispatch, withJsonFormsLayoutProps} from '@jsonforms/react';
import PropTypes from 'prop-types';
import './styles.scss';

const CustomLayoutRenderer = ({
  schema,
  uischema,
  path,
  renderers,
  cells,
  enabled,
  direction = 'column',
  gap = 'normal',
  visible,
  label = '',
  labelStyles = {} /* Customise label styles using uiSchema */,
  layoutStyles = {} /* Customise layout styles using uiSchema */
}) => {
  return (
    visible && (
      <>
        {label ? (
          <div
            className={`font-xs label-title-render ${uischema.label_classname ?? ''}`}
            style={{...labelStyles}}>
            <h6 className='font-lg mb-2 font-bold'>{label}</h6>
          </div>
        ) : (
          <></>
        )}
        <div
          className={`${direction === 'column' ? 'vertical-layout' : 'horizontal-layout'} ${gap === 'normal' ? 'gap-normal' : 'gap-simple'} ${uischema.className ?? ''} ${uischema.class_name ?? ''}`}
          style={{...layoutStyles}}>
          {visible &&
            uischema.elements.map((child, index) => (
              <div
                className={`${direction === 'column' ? 'vertical-layoutItem-item' : 'horizontal-layoutItem-item'} horizontal-layoutItem-${index} ${child.child_class_name ?? ''}`}
                style={{...child.layoutItemStyles}}
                key={`${path}-${index}`}>
                <JsonFormsDispatch
                  schema={schema}
                  uischema={child}
                  path={path}
                  enabled={enabled}
                  renderers={renderers}
                  cells={cells}
                  key={index}
                />
              </div>
            ))}
        </div>
      </>
    )
  );
};
export const CustomLayoutRendererControl =
  withJsonFormsLayoutProps(CustomLayoutRenderer);

CustomLayoutRenderer.propTypes = {
  schema: PropTypes.object.isRequired,
  uischema: PropTypes.shape({
    label_classname: PropTypes.string,
    className: PropTypes.string,
    class_name: PropTypes.string,
    elements: PropTypes.arrayOf(PropTypes.object).isRequired
  }).isRequired,
  path: PropTypes.string,
  renderers: PropTypes.array.isRequired,
  cells: PropTypes.array.isRequired,
  enabled: PropTypes.bool.isRequired,
  direction: PropTypes.oneOf(['column', 'row']),
  gap: PropTypes.oneOf(['normal', 'simple']),
  visible: PropTypes.bool.isRequired,
  label: PropTypes.string,
  labelStyles: PropTypes.object,
  layoutStyles: PropTypes.object
};
